export const LicensePlateQueryStringKey = 'kenteken'